import * as yup from 'yup';

import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';

import { FORM_FIELDS } from './constants';

export const schema = yup.object().shape({
  [FORM_FIELDS.DELIVERY_METHOD.name]: yup
    .string()
    .required('A delivery method is required'),
  [FORM_FIELDS.RECIPIENT_EMAIL.name]: yup
    .string()
    .when(FORM_FIELDS.DELIVERY_METHOD.name, ([method], sch) => {
      return method === DeliveryMethod.Email
        ? sch.required('An email address is required').email('Email is invalid')
        : sch.notRequired();
    }),
});
